module.exports = __webpack_public_path__ + "img/xf.08dc62a8.png";